import { localizeAmountAndCurrency } from '%app/js/common/services/localizeMoney';

export default class CartController {
    constructor($scope, cartStorage, bulgarianEuroConversion) {
        this.$scope = $scope;
        this.cartStorage = cartStorage;
        this.bulgarianEuroConversion = bulgarianEuroConversion;
        this.showCartSummary = false;
    }

    init(parameters) {
        this.cartStorage.setSumBeforeDiscount(parameters.sum_before_discount);
        this.cartStorage.setDiscountAmount(parameters.discount_amount);
        this.cartStorage.setDiscountedSum(parameters.discounted_sum);
        this.cartStorage.setCurrency(parameters.currency);
        this.cartStorage.setIsEurPriceFirst(parameters.is_eur_price_first);
        this.cartStorage.setIsBgnCurrencyMigration(parameters.is_bgn_currency_migration);

        this.$scope.$watchGroup(
            [
                () => this.cartStorage.getSumBeforeDiscount(),
                () => this.cartStorage.getDiscountAmount(),
                () => this.cartStorage.getDiscountedSum(),
                () => this.cartStorage.getCurrency(),
            ],
            ([sumBeforeDiscount, discountAmount, discountedSum, currency]) => {
                this.sumBeforeDiscount = sumBeforeDiscount;
                this.discountAmount = discountAmount;
                this.discountedSum = discountedSum;
                this.currency = currency;

                const sumBeforeDiscountLocalized = localizeAmountAndCurrency(sumBeforeDiscount, currency);
                const discountAmountLocalized = localizeAmountAndCurrency(discountAmount, currency);
                const discountedSumLocalized = localizeAmountAndCurrency(discountedSum, currency);

                if (parameters.is_bgn_currency_migration) {
                    const dualCurrency = this.formatDualCurrency(
                        sumBeforeDiscount,
                        discountAmount,
                        discountedSum,
                        currency,
                    );

                    if (dualCurrency) {
                        this.sumBeforeDiscountLocalized = dualCurrency.sumBeforeDiscount;
                        this.discountAmountLocalized = dualCurrency.discountAmount;
                        this.discountedSumLocalized = dualCurrency.discountedSum;

                        return;
                    }
                }

                this.sumBeforeDiscountLocalized = sumBeforeDiscountLocalized;
                this.discountAmountLocalized = discountAmountLocalized;
                this.discountedSumLocalized = discountedSumLocalized;
            },
        );
    }

    toggleCartSummary() {
        this.showCartSummary = !this.showCartSummary;
    }

    formatDualCurrency(sumBeforeDiscount, discountAmount, discountedSum, currency) {
        if (!this.bulgarianEuroConversion.isBgn(currency) && !this.bulgarianEuroConversion.isEur(currency)) {
            return null;
        }

        let convert;
        let targetCurrency;

        if (this.bulgarianEuroConversion.isBgn(currency)) {
            convert = (amount) => this.bulgarianEuroConversion.convertBgnToEur(amount);
            targetCurrency = 'EUR';
        } else {
            convert = (amount) => this.bulgarianEuroConversion.convertEurToBgn(amount);
            targetCurrency = 'BGN';
        }

        const sumBeforeDiscountConverted = localizeAmountAndCurrency(convert(sumBeforeDiscount), targetCurrency);
        const discountAmountConverted = localizeAmountAndCurrency(convert(discountAmount), targetCurrency);
        const discountedSumConverted = localizeAmountAndCurrency(convert(discountedSum), targetCurrency);
        const sumBeforeDiscountOriginal = localizeAmountAndCurrency(sumBeforeDiscount, currency);
        const discountAmountOriginal = localizeAmountAndCurrency(discountAmount, currency);
        const discountedSumOriginal = localizeAmountAndCurrency(discountedSum, currency);

        const currencies = {};
        currencies[targetCurrency] = {
            sumBeforeDiscount: sumBeforeDiscountConverted,
            discountAmount: discountAmountConverted,
            discountedSum: discountedSumConverted,
        };
        currencies[currency] = {
            sumBeforeDiscount: sumBeforeDiscountOriginal,
            discountAmount: discountAmountOriginal,
            discountedSum: discountedSumOriginal,
        };

        return this.buildDualCurrencyFormat(currencies);
    }

    buildDualCurrencyFormat(currencies) {
        if (this.cartStorage.getIsEurPriceFirst()) {
            return {
                sumBeforeDiscount: `${currencies.EUR.sumBeforeDiscount}|${currencies.BGN.sumBeforeDiscount}`,
                discountAmount: `${currencies.EUR.discountAmount}|${currencies.BGN.discountAmount}`,
                discountedSum: `${currencies.EUR.discountedSum}|${currencies.BGN.discountedSum}`
            };
        }

        return {
            sumBeforeDiscount: `${currencies.BGN.sumBeforeDiscount}|${currencies.EUR.sumBeforeDiscount}`,
            discountAmount: `${currencies.BGN.discountAmount}|${currencies.EUR.discountAmount}`,
            discountedSum: `${currencies.BGN.discountedSum}|${currencies.EUR.discountedSum}`
        };
    }
}

CartController.$inject = [
    '$scope',
    'cartStorage',
    'bulgarianEuroConversion',
];
